import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { Tc } from '../../../core/_infrastructure/types/common';
import { RegAgenteControlViewModel, RegAgenteControlComunidadAutonomaViewModel } from './agentecontrol.types';
import { AgenteControlService } from './agentecontrol.service';
import { CustomValidator } from '../../../core/_infrastructure/classes/customValidator';
import { UsuarioViewModel } from '../../usuarios/usuarios.types';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';

@Component({
    selector: 'app-agentecontrol-edit',
    templateUrl: './agentecontrol-edit.component.html',
})
export class AgenteControlEditComponent extends ComponentBase implements OnInit {
    /** nombrescientificos-edit ctor */

    editMode: boolean;
    editTitle = 'Nuevo';
    listProvincia: Tc[];
    usuarioAC: UsuarioViewModel;
    comunidadesActivas: RegAgenteControlComunidadAutonomaViewModel[];
    comunidadesNoActivas: RegAgenteControlComunidadAutonomaViewModel[];
    visibilitySpinner = false;
    isCollapsedEntidad = false;
    habilitarGuardar = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificationService: NotificationService,
        private confirmationService: ConfirmationService,
        private agenteControlService: AgenteControlService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);

        this.usuarioAC = new UsuarioViewModel();
        this.usuarioAC.TwRegAgenteControl = new RegAgenteControlViewModel();
    }

    ngOnInit() {
        this.createForm();

        let id = +this.activatedRoute.snapshot.params['id'];

        if (id) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.agenteControlService.getAgenteControl(id).subscribe(result => {
                this.usuarioAC = result;

                //Filtro las comunidades que estan activas
                this.comunidadesActivas = this.usuarioAC.TwRegAgenteControl.TwRegAgenteControlComunidadAutonomaCollection.filter(x => x.ActivacionInicial).sort(
                    function (a, b) {
                        return a.Descripcion.localeCompare(b.Descripcion);
                    },
                );

                //Filtro las comunidades que NO estan activas
                this.comunidadesNoActivas = this.usuarioAC.TwRegAgenteControl.TwRegAgenteControlComunidadAutonomaCollection.filter(
                    x => !x.ActivacionInicial,
                ).sort(function (a, b) {
                    return a.Descripcion.localeCompare(b.Descripcion);
                });

                this.updateForm();
            });

            this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_AGENTE_CONTROL).Visible;

            if (!this.habilitarGuardar) {
                this.DisableControls();
            }
            //En edicion se deshabilita para no poder modificarlo
            this.form.controls['Nif'].disable();
            this.form.controls['Email'].disable();
            this.form.controls['Activo'].disable();
        } else {
            this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_AGENTE_CONTROL).Visible;
        }

        this.globalService.getProvincias().subscribe(res => {
            this.listProvincia = res;
        });
    }

    DisableControls() {
        this.form.controls['Nombre'].disable();
        this.form.controls['Apellidos'].disable();
        this.form.controls['Nif'].disable();
        this.form.controls['Ropo'].disable();
        this.form.controls['IdProvincia'].disable();
        this.form.controls['Direccion'].disable();
        this.form.controls['Localidad'].disable();
        this.form.controls['CodigoPostal'].disable();
        this.form.controls['Telefono'].disable();
        this.form.controls['Email'].disable();
        this.form.controls['Activo'].disable();
        this.form.controls['Observaciones'].disable();
    }

    createForm() {
        this.form = this.fb.group({
            Nombre: ['', Validators.required],
            Apellidos: ['', Validators.required],
            Nif: ['', Validators.compose([Validators.required, CustomValidator.NIFValidator])],
            Ropo: ['', Validators.required],
            IdProvincia: [null, Validators.required],
            Direccion: ['', Validators.required],
            Localidad: ['', Validators.required],
            CodigoPostal: ['', Validators.required],
            Telefono: ['', Validators.required],
            Email: ['', Validators.compose([Validators.required, CustomValidator.emailEmptyValidator])],
            Observaciones: '',
            //Fecha: '',
            FechaCreacion: '',
            FechaActivacion: '',
            FechaBaja: '',
            Activo: true,
        });
    }

    updateForm() {
        this.form.setValue({
            Nombre: this.usuarioAC.Nombre,
            Apellidos: this.usuarioAC.Apellidos,
            Nif: this.usuarioAC.Nif,
            Ropo: this.usuarioAC.TwRegAgenteControl.Ropo,
            IdProvincia: this.usuarioAC.TwRegAgenteControl.IdProvincia,
            Direccion: this.usuarioAC.TwRegAgenteControl.Direccion,
            Localidad: this.usuarioAC.TwRegAgenteControl.Localidad,
            CodigoPostal: this.usuarioAC.TwRegAgenteControl.CodigoPostal,
            Telefono: this.usuarioAC.TwRegAgenteControl.Telefono,
            Email: this.usuarioAC.Email,
            Observaciones: this.usuarioAC.TwRegAgenteControl.Observaciones,
            //Fecha: this.agenteControl.Fecha,
            FechaCreacion: new Date(this.usuarioAC.FechaCreacion),
            FechaActivacion: this.usuarioAC.FechaActivacion != null ? new Date(this.usuarioAC.FechaActivacion) : '',
            FechaBaja: this.usuarioAC.FechaBaja != null ? new Date(this.usuarioAC.FechaBaja) : '',
            Activo: this.usuarioAC.TwRegAgenteControl.Activo,
        });
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos');
            this.isCollapsedEntidad = false;
            return;
        }

        this.visibilitySpinner = true;

        let usuarioAC = new UsuarioViewModel();
        usuarioAC.TwRegAgenteControl = new RegAgenteControlViewModel();

        usuarioAC.Nombre = this.form.value.Nombre;
        usuarioAC.Apellidos = this.form.value.Apellidos;
        usuarioAC.Nif = this.form.value.Nif != null ? this.form.value.Nif : this.usuarioAC.Nif;
        usuarioAC.TwRegAgenteControl.Ropo = this.form.value.Ropo;
        usuarioAC.TwRegAgenteControl.IdProvincia = this.form.value.IdProvincia;
        usuarioAC.TwRegAgenteControl.Direccion = this.form.value.Direccion;
        usuarioAC.TwRegAgenteControl.Localidad = this.form.value.Localidad;
        usuarioAC.TwRegAgenteControl.CodigoPostal = this.form.value.CodigoPostal;
        usuarioAC.TwRegAgenteControl.Telefono = this.form.value.Telefono;
        usuarioAC.TwRegAgenteControl.Activo = this.form.get('Activo')?.value;
        usuarioAC.Email = this.form.value.Email != null ? this.form.value.Email : this.usuarioAC.Email;
        usuarioAC.TwRegAgenteControl.Observaciones = this.form.value.Observaciones;

        //PERFILES
        usuarioAC.TUsuarioPerfilCollection = this.usuarioAC.TUsuarioPerfilCollection;

        if (this.editMode) {
            usuarioAC.FechaCreacion = this.form.value.FechaCreacion;
        }

        usuarioAC.Id = this.usuarioAC.Id;
        usuarioAC.Activo = this.usuarioAC.Activo;
        usuarioAC.FechaActivacion = this.usuarioAC.FechaActivacion;
        usuarioAC.FechaBaja = this.usuarioAC.FechaBaja;

        if (this.editMode) {
            this.agenteControlService.editAgenteControl(usuarioAC).subscribe({
                next: () => {
                    this.addSuccessMessage('Agente de Control modificado correctamente');
                    this.visibilitySpinner = false;
                    this.isCollapsedEntidad = false;
                    this.onBack();
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.isCollapsedEntidad = false;
                },
            });
        } else {
            this.agenteControlService.getSiUsuarioExisteComoEA(usuarioAC).subscribe({
                next: res => {
                    if (res == true) {
                        this.confirmationService.confirm({
                            message:
                                'El usuario Agente de Control que intenta añadir ya está dado de alta como usuario técnico de Entidad Auditora, ¿quiere asignarle el perfil de Agente de Control también?',
                            accept: () => {
                                this.agenteControlService.addTecnicoExistenteComoACyEA(usuarioAC).subscribe({
                                    next: () => {
                                        this.addSuccessMessage('Agente de Control añadido correctamente');
                                        this.visibilitySpinner = false;
                                        this.isCollapsedEntidad = false;
                                        this.onBack();
                                    },
                                    error: error => {
                                        this.catchServerError(error);
                                        this.visibilitySpinner = false;
                                        this.isCollapsedEntidad = false;
                                    },
                                });
                            },
                            reject: () => {
                                this.visibilitySpinner = false;
                                return;
                            },
                        });
                    } else {
                        this.agenteControlService.createAgenteControl(usuarioAC).subscribe({
                            next: () => {
                                this.addSuccessMessage('Agente de Control añadido correctamente');
                                this.visibilitySpinner = false;
                                this.isCollapsedEntidad = false;
                                this.onBack();
                            },
                            error: error => {
                                this.catchServerError(error);
                                this.visibilitySpinner = false;
                                this.isCollapsedEntidad = false;
                            },
                        });
                    }
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.isCollapsedEntidad = false;
                },
            });
        }
    }

    onAddAgenteControlCa() {
        this.router.navigate([this.router.url, 'agentescontrolca', 'create']);
    }

    onEditAgenteControlCa(item: RegAgenteControlComunidadAutonomaViewModel) {
        this.router.navigate([this.router.url, 'agentescontrolca', 'edit', item.Id]);
    }

    onDeleteAgenteControlCa(item: RegAgenteControlComunidadAutonomaViewModel) {
        //this.confirmationService.confirm({
        //    message: '¿Está seguro de dar de baja la Comunidad Autónoma ' + item.Descripcion,
        //    accept: () => {
        //        //this.agenteControl.TwRegAgenteControlComunidadAutonomaCollection.splice(this.agenteControl.TwRegAgenteControlComunidadAutonomaCollection.indexOf(item), 1);

        //this.agenteControlService.deleteAgenteControlComunidadAutonoma(item.Id);

        //    }
        //});

        this.confirmationService.confirm({
            message: '¿Está seguro de dar de baja la Comunidad Autónoma ' + item.Descripcion,
            accept: () => {
                //Actual logic to perform a confirmation
                this.agenteControlService.deleteAgenteControlComunidadAutonoma(item.Id).subscribe({
                    next: () => {
                        this.addSuccessMessage('Comunidad Autónoma dada de baja correctamente');
                        const index = this.usuarioAC.TwRegAgenteControl.TwRegAgenteControlComunidadAutonomaCollection.findIndex(({ Id }) => Id === item.Id);
                        this.comunidadesActivas = this.usuarioAC.TwRegAgenteControl.TwRegAgenteControlComunidadAutonomaCollection.filter((_, s) => s !== index);
                    },
                    error: () => this.addErrorMessage('Error al borrar la Campaña.'),
                });
            },
        });
    }

    onBack() {
        this.router.navigate(['/mantenimiento/registros/agentescontrol']);
    }
}
